import React, { createContext, useContext, useState, useEffect } from "react";
import { isNativeApp, sendToNative } from "../lib/native";
import { useNativeTheme } from "../hooks/useNativeTheme";

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme || "dark";
  });
  const nativeTheme = useNativeTheme();
  useEffect(() => {
    if (isNativeApp() && nativeTheme) {
      setThemeState(nativeTheme);
    }
  }, [nativeTheme]);

  useEffect(() => {
    localStorage.setItem("theme", theme);

    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
      root.classList.remove("light");
    } else {
      root.classList.add("light");
      root.classList.remove("dark");
    }
    if (isNativeApp()) {
      sendToNative("theme_change", { theme });
    }
  }, [theme]);

  const setTheme = (newTheme) => {
    setThemeState(newTheme);
  };

  const toggleTheme = () => {
    setThemeState((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
